import push from '../../utils/routing';

export default ({ spaceId, assignmentId, submissionId, reportType }) =>
  () =>
    push(
      `/dashboard/${spaceId}/journey/reports/${assignmentId}/${submissionId}/${reportType}`
    );
